<template>
  <nav class="navbar is-fixed-top is-primary hide-on-print">
    <div class="container">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item is-size-5">FirestopDoc</router-link>

        <div role="button" class="navbar-burger burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{ 'is-active': showNav }">
        <div class="navbar-start" v-if="user">
          <router-link class="navbar-item" to="/projectlist">Projectenlijst</router-link>
        </div>

        <div class="navbar-end">
          <div class="navbar-item has-dropdown is-hoverable" v-if="user">
            <a class="navbar-link" v-if="user != null">Office</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/logbook">Logboek</router-link>
              <router-link v-if="adminClaim || dataAdminClaim" class="navbar-item" to="/addphoto"
                >Foto Toevoegen</router-link
              >
              <router-link class="navbar-item" to="/projectstatus">Project Status</router-link>
            </div>
          </div>

          <div class="navbar-item has-dropdown is-hoverable" v-if="user != null && (adminClaim || dataAdminClaim)">
            <a class="navbar-link">Admin</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/accounts">Accounts</router-link>
            </div>
          </div>
          <a class="navbar-item" href="mailto:info@qalcsoft.com">Help</a>
          <router-link class="navbar-item" to="/login" v-if="user == null">Aanmelden</router-link>
          <router-link class="navbar-item" to="/register" v-if="user == null">Registreren</router-link>
          <router-link class="navbar-item" to="/logout" v-if="user != null">Afmelden</router-link>
          <router-link class="navbar-item" to="/me" v-if="user != null"
            >{{ user.firstName }} {{ user.lastName }}</router-link
          >
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  // [name, delimiters, functional, model]
  // [components, directives, filters]
  // [parent, mixins, extends, provide, inject]
  // el, template, props, propsData, data, computed, watch
  // LIFECYCLE_HOOKS: beforeCreate, created, beforeMount, mount, beforeUpdate, updated, beforeDestroyed, destroyed
  // methods, render, renderError
  data() {
    return {
      showNav: false
    }
  },
  computed: {
    ...mapGetters(['user', 'adminClaim', 'dataAdminClaim'])
  }
}
</script>

<style lang="scss">
/* nav{
    text-align: left;
    background-color: steelblue;
    padding: 4px;
} */
.title {
  font-size: 60px;
  color: white;
}
a {
  text-decoration: none;
}
.is-size-5 {
  font-size: 1.8rem !important;
}
.navbar-item {
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue